import { SET_CASH_IS_VISIBLE } from './constants';

export const setCashIsVisible = isVisible => ({
    type: SET_CASH_IS_VISIBLE,
    isVisible,
});



// WEBPACK FOOTER //
// ./src/containers/Inputs/CASH/actions.js